export const BASE_TEAMS_PRO_URL = `https://www.teams-pro.com/`;
export const SUGGEST_FEATURE_URL = "https://ideas.teams-pro.com/";
export const ZOOM_LEVEL_LIMIT = 2.6;
export const PARTICIPANT_NO_ID = "Guest Id";
